module.exports = __webpack_public_path__ + "img/about-image.672a1e85.svg";